export default class ClubFinancialAccountingDatevSettings {
    static fromData(data) {
        if (!data) {
            return;
        }

        const datevSettings = new ClubFinancialAccountingDatevSettings();

        datevSettings.id = data.id;
        datevSettings.clientNumber = data.clientNumber;
        datevSettings.consultantNumber = data.consultantNumber;
        datevSettings.endOfMonthDate = data.endOfMonthDate;
        datevSettings.annualStatementPeriods = data.annualStatementPeriods;
        datevSettings.variousAccounts = data.variousAccounts;

        return datevSettings;
    }

    serialize() {
        const endOfMonthDate = this.endOfMonthDate !== '' && this.endOfMonthDate !== null
            ? Number(this.endOfMonthDate)
            : null;
        return {
            id: this.id,
            clientNumber: this.clientNumber,
            consultantNumber: this.consultantNumber,
            endOfMonthDate,
            annualStatementPeriods: this.annualStatementPeriods,
            variousAccounts: this.variousAccounts,
        };
    }
}
